import { builder } from 'common/js/configs';
import { formatConfigUnmarshaller as HeaderAdConfigUnmarshaller } from '../header-ad';

export const formatConfigUnmarshaller = {
  ...HeaderAdConfigUnmarshaller,
  enableDynamicFooterResize: builder.boolean('enable_dynamic_footer_resize', {
    defaultValue: false
  })
};
